export default __webpack_public_path__ + "static/education-equity-hero-ae3aee4bf27d4f996e9a0062665af82b.webp";